// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"27d3e1b2","311":"6843329b","346":"c7ad4226","720":"243ed08b","860":"0997fd96","877":"09780745","989":"5b60c519"}[chunkId] + ".chunk.css";
};